import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const RANGE_DASH = '-';
const LOWER_BOUNDARY_INDEX = 0;
const UPPER_BOUNDARY_INDEX = 1;

export class FinancialStatementImportInterpretationHelper {
    public static validateAccountNumber(): ValidatorFn | null {
        return (accountNumberFormControl: AbstractControl): ValidationErrors | null => {
            const isNumericRegex = new RegExp('^[0-9]+$');
            let lowerBoundaryValid = false;

            if (accountNumberFormControl == null) {
                return null;
            }
            const accountNumberValue = accountNumberFormControl.value;

            if (accountNumberValue == null || accountNumberValue === '') {
                return null;
            }
            const accountNumberSplittedArray = accountNumberValue.split(RANGE_DASH);
            const lowerBoundaryString = accountNumberSplittedArray[LOWER_BOUNDARY_INDEX];
            const upperBoundaryString = accountNumberSplittedArray[UPPER_BOUNDARY_INDEX];
            const lowerBoundaryNumber = Number(lowerBoundaryString);
            const upperBoundaryNumber = Number(upperBoundaryString);
            if (
                isNumericRegex.test(lowerBoundaryString) &&
                Number.isInteger(lowerBoundaryNumber) &&
                lowerBoundaryNumber > 0
            ) {
                lowerBoundaryValid = true;
            }
            if (lowerBoundaryValid && upperBoundaryString == null) {
                return null;
            }
            if (
                lowerBoundaryValid &&
                isNumericRegex.test(upperBoundaryString) &&
                Number.isInteger(upperBoundaryNumber) &&
                upperBoundaryNumber > 0
            ) {
                return null;
            }
            return { invalidAccountNumberInput: true };
        };
    }
}
